/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry, molecular biology and bioinformatics calculators.`)
};

const es_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de química, biología molecular y bioinformática.`)
};

const de_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner für Chemie, Molekularbiologie und Bioinformatik.`)
};

const nl_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekenmachines voor scheikunde, moleculaire biologie en bio-informatica.`)
};

const fr_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateurs de chimie, biologie moléculaire et bio-informatique.`)
};

const it_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatori di chimica, biologia molecolare e bioinformatica.`)
};

const pt_br2_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de química, biologia molecular e bioinformática.`)
};

const pt_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de química, biologia molecular e bioinformática.`)
};

const ja_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化学、分子生物学、バイオインフォマティクスの計算機。`)
};

const zh_cat_science_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化学、分子生物学与生物信息学计算器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_science_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_science_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_science_desc", locale)
	if (locale === "en") return en_cat_science_desc(inputs)
	if (locale === "es") return es_cat_science_desc(inputs)
	if (locale === "de") return de_cat_science_desc(inputs)
	if (locale === "nl") return nl_cat_science_desc(inputs)
	if (locale === "fr") return fr_cat_science_desc(inputs)
	if (locale === "it") return it_cat_science_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_science_desc(inputs)
	if (locale === "pt") return pt_cat_science_desc(inputs)
	if (locale === "ja") return ja_cat_science_desc(inputs)
	return zh_cat_science_desc(inputs)
};